
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { MensajeComponent } from 'src/app/mensaje/mensaje.component';
import { ClientePagos } from 'src/app/models/cliente-pagos.model';
import { ClientesPagoDataService } from 'src/app/service/data/clientes-pago-data.service';
import { OrdenDataService } from 'src/app/service/data/orden-data.service';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe, registerLocaleData } from '@angular/common';
import localeES from '@angular/common/locales/es';
import { Evento } from 'src/app/eventos/evento.model';
import { Localidad } from 'src/app/models/localidad.model';
import { EventoDataService } from 'src/app/service/data/evento-data.service';
import { HardcodedAutheticationService } from 'src/app/service/hardcoded-authetication.service';
import { LoginComponent } from 'src/app/login/login.component';


@Component({
  selector: 'app-compra-oculta',
  templateUrl: './compra-oculta.component.html',
  styleUrl: './compra-oculta.component.css',
  standalone: false
})
export class CompraOcultaComponent implements OnInit {
  miId
  valorTotal: number;
  evento: Evento;
  cantidadTotal: number;
  cantidades: number[];
  cargando: boolean;
  idLocalidad: number;
  localidades: Localidad[];

  urlPrimeraImagenTipo1: string;
  usuario: string;
  cliente: ClientePagos;


  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private service: EventoDataService,
    private autenticador: HardcodedAutheticationService,
    private router: Router,
    private clienteDataService: ClientesPagoDataService,
    private ordenService: OrdenDataService
  ) { }

  ngOnInit(): void {
    this.cantidades = [];
    this.valorTotal = 0;
    this.cantidadTotal = 0;
    this.evento = new Evento();
    this.cargando = true;
    this.localidades = [];

    this.route.paramMap.subscribe(params => {
      this.miId = params.get('id');
      this.cargarEvento();
    });

    this.autenticar();
  }

  cargarEvento(): void {
    this.service.getEventoIdPerfil(this.miId).subscribe({
      next: response => {
        if (response) {
          this.handleGetSuccesfull(response);
          this.darURL(1);
          this.cargarLocalidades();
        } else {
          this.cargando = false;
          this.mensaje("No se encontró información del evento");
        }
      },
      error: error => {
        this.cargando = false;
        this.mensaje("Error al cargar el evento");
      }
    });
  }

  cargarLocalidades(): void {
    // Cargar localidades con etapas en estado 4 (oculto)
    this.service.getLocalidadesByEtapaEstaoAndEvento(this.miId, 4).subscribe({
      next: response => {
        console.log(response);
        
        if (response.length > 0) {
          this.localidades = response;
          console.log(this.localidades)
          // Inicializar las cantidades para cada localidad
          for (let i = 0; i < this.localidades.length; i++) {
            this.cantidades.push(0);
          }
          this.cargando = false;
        } else {
          this.cargando = false;
          this.mensaje("No hay etapas disponibles para este evento");
        }
      },
      error: error => {
        this.cargando = false;
        this.mensaje("Error al cargar las etapas del evento");
      }
    });
  }



  handleGetSuccesfull(response) {
    this.evento = response.evento;
  }

  agregarBoletasACompra(i) {
    this.valorTotal = 0;
    this.cantidadTotal = 0;
    
    // Recalcular totales para todas las localidades seleccionadas
    for (let j = 0; j < this.localidades.length; j++) {
      const localidad = this.localidades[j];
      this.valorTotal += this.cantidades[j] * (localidad.precio + localidad.servicio + localidad.servicio_iva) * localidad.cantidadPersonasPorTicket;
      this.cantidadTotal += this.cantidades[j];
    }
  }

  validar(i) {
    let encontro: boolean = false;
    let deshabilitar: boolean = true;
    let k;

    for (let j = 0; j < this.cantidades.length; j++) {
      if (this.cantidades[j] > 0) {
        encontro = true;
        k = j;
      }
    }
    
    if (encontro && k == i) {
      deshabilitar = false;
    }
    else if (!encontro) {
      deshabilitar = false;
    }
    
    return deshabilitar;
  }

  AbrirCarrito(): void {
    if (this.cantidadTotal == 0) {
      this.mensaje("Selecciona lo que deseas comprar");
      return;
    }

    if (this.autenticador.getUsuario()) {
      if (!this.cliente) {
        this.autenticar().then(() => {
          this.crearOrden();
        });
      }
      else {
        this.crearOrden();
      }
    }
    else {
      this.mensaje("Debes estar registrado en All Tickets para poder realizar tu compra, en caso de no estarlo por favor crea una cuenta nueva", true);
    }
  }

  crearOrden(): void {
    const numerosNoCero = this.cantidades.filter(num => num !== 0);
    if (numerosNoCero.length == 1) {
      const posicion = this.cantidades.indexOf(numerosNoCero[0]);
      let localidad: Localidad = this.localidades[posicion];
      this.idLocalidad = localidad.id;
      let tipo: number = (localidad.tipo == 1 || localidad.tipo == 3) ? 4 : 1;
      this.cargando = true;

      this.ordenService.crearOrdenClienteCompra(this.cantidadTotal, this.idLocalidad, tipo, this.evento.id, this.cliente).subscribe({
        next: response => {
          if (response.ordenId) {

            this.router.navigate([`/eventos/carrito/${response.ordenId}`]);
          }
          else if (response.mensaje) {
            this.cargando = false;
            this.mensaje(response.mensaje);
          }
        }, 
        error: error => {
          this.cargando = false;
          this.mensaje("Sucedió un error al generar la orden, por favor intenta nuevamente");
        }
      });
    } else {
      this.mensaje("No se permite la compra de más de una localidad por compra");
    }
  }

  darFecha(evento: Evento): string {
    if (evento.fecha == null) {
      return 'Por confirmar';
    }

    registerLocaleData(localeES, 'es');
    let dataPipe: DatePipe = new DatePipe('es');
    let Word = dataPipe.transform(evento.fecha, 'EEE dd');
    Word = Word[0].toUpperCase() + Word.substr(1).toLowerCase();

    let Word2 = dataPipe.transform(evento.fecha, 'MMM');
    Word2 = Word2[0].toUpperCase() + Word2.substr(1).toLowerCase();

    let fecha = Word + " de " + Word2 + " de " + dataPipe.transform(evento.fecha, 'yyyy');

    return fecha;
  }

  mensaje(mensaje, login?): void {
    const dialogRef = this.dialog.open(MensajeComponent, {
      width: '600px',
      maxHeight: '250px',
      data: {
        mensaje: mensaje,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (login) {
        this.openDialog();
      }
    });
  }
  
  openDialog(): void {
    const dialogRef = this.dialog.open(LoginComponent, {
      width: '600px',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.autenticar();
    });
  }

  darURL(tipo) {
    const primeraImagenTipo1 = this.evento.imagenes.find(imagen => imagen.tipo === tipo);
    this.urlPrimeraImagenTipo1 = "";
    if (primeraImagenTipo1) {
      this.urlPrimeraImagenTipo1 = primeraImagenTipo1.url;
    }
  }

  async autenticar() {
    this.usuario = this.autenticador.getUsuario();
    if (this.usuario) {
      return new Promise((resolve) => {
        this.clienteDataService.getClientePago(this.usuario).subscribe({
          next: response => {
            this.cliente = response.cliente;
            resolve(true);
          }
        });
      });
    }
  }


}